import { render, staticRenderFns } from "./vcImportExcel.vue?vue&type=template&id=20759a8a&"
import script from "./vcImportExcel.vue?vue&type=script&lang=js&"
export * from "./vcImportExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports